export default __webpack_public_path__ + "static/media/Etched Kuthcheman Poniard.3b0b194d.jpg";